"use client";

import * as React from "react";

import { capitalizeFirstLetter } from "@/lib/utils";
import type { AuthUser } from "@/types/auth";

interface AvatarProps {
  user?: AuthUser | null;
  className?: string;
  id?: number;
  name?: string;
  email?: string;
  avatar?: string;
}

const Avatar: React.FC<AvatarProps> = ({ user, className = "" }) => {
  if (!user) return null;
  if (!user?.photo)
    return (
      <div
        className={`relative inline-flex items-center justify-center w-10 h-10 overflow-hidden bg-slate-400/25 rounded-full ${className}`}
      >
        <span className="font-medium text-xl md:text-2xl ">
          {" "}
          {capitalizeFirstLetter(user?.firstName[0])}
        </span>
      </div>
    );
  return (
    <div
      className={`relative h-10 w-10 overflow-hidden rounded-full ${className}`}
    >
      <img
        className="h-10 w-10 rounded-full"
        src={user?.photo}
        alt={user?.firstName}
      />
    </div>
  );
};

export default Avatar;
